import { usePagination, UsePaginationProps } from 'react-instantsearch';

export const PaginationVirtual = (props: UsePaginationProps) => {
  usePagination(props);
  return null;
};
